module.exports = __webpack_public_path__ + "static/img/lineup_cmt_c_strawberry.e33da01.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lineup_cmt_c_strawberry.svg
// module id = imfv
// module chunks = 1